import Vue from 'vue'
import Router from 'vue-router'
import index from '@/components/home'
import login from '@/components/login'
import parentsCare from '@/components/parentsCare'
import service from '@/components/service'
import voucher from '@/components/voucher'
import clay from '@/components/clay'
import figma from '@/components/figma'
Vue.use(Router)
var router = new Router({
    linkActiveClass: 'active',
    scrollBehavior(to, from, savedPosition) {
        return {
            x: 0,
            y: 0
        }
    },
    routes: [{
            path: '/',
            name: 'index',
            component: index
        },
        {
            path: '/index',
            name: 'index',
            component: index
        },
        {
            path: '/login',
            name: '登录',
            component: login
        },
        {
            path: '/parentsCare',
            name: '家长关心',
            component: parentsCare
        },
        {
            path: '/voucher',
            name: '充值中心',
            component: voucher
        },
        {
            path: '/service',
            name: '服务协议',
            component: service
        },
        {
            path: '/clay',
            name: '粘土',
            component: clay
        },{
            path: '/figma',
            name: 'figma',
            component: figma
        }
    ]

})

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js